import type { Notification } from '@novu/react';
import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { AnnouncementCreateInputDto } from './model';

export const queryAnnouncements = queryOptions({
  queryKey: ['公告', '当前公告列表'],
  queryFn: async () => {
    return http.get('announcements').json<Notification[]>();
  },
});

export const createAnnouncementMutation = mutationOptions({
  mutationKey: queryAnnouncements.queryKey,
  mutationFn: async (input: AnnouncementCreateInputDto) => {
    return http.post<void>('announcements', { json: input });
  },
});

export const deleteAnnouncement = (announcement_id: string) => {
  return http.delete<void>(`announcements/${announcement_id}`);
};

export const archiveAnnouncement = (announcement_id: string) => {
  return http.put<void>(`announcements/${announcement_id}/archived`);
};
